//add action to all elements with a "copy to clipboard" action
document.querySelectorAll('[data-action="copy-to-clipboard"][data-target]').forEach(element => {
    element.addEventListener('click', async (event) => {
        if ((target = document.querySelector(`${element.dataset.target}`)) !== null) {
            await navigator.clipboard.writeText(target.innerText);
        }
    }); 
});